/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box, useMultiStyleConfig, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const OptionItems = ({optionItems}) => {
    const cartStyles = useMultiStyleConfig('CartStyles')
    return (
        <Box className="product-options">
            {optionItems?.map((i) => (
                <Text
                    key={i.itemId}
                    className="product-option"
                    {...cartStyles.lineItems.item.productOptions}
                >
                    {i.itemText}
                </Text>
            ))}
        </Box>
    )
}

OptionItems.propTypes = {
    optionItems: PropTypes.array
}

export default OptionItems
